import { ProductType } from '~/interfaces/product';

/**
 * Human-readable labels for product types displayed on the subscriber-facing side
 */
export const PRODUCT_TYPE_LABELS: Record<ProductType, string> = {
  [ProductType.FILE_DOWNLOAD]: 'File / Download',
  [ProductType.LINK_MEDIA]: 'Link / Media',
  [ProductType.COACHING_SESSION]: 'Coaching / 1:1',
};

/**
 * Get a formatted product type label
 * Falls back to formatting the raw product type if not found in the map
 *
 * @param productType - The product type value
 * @returns {string} - The formatted product type label
 */
export const getProductTypeLabel = (productType: string | null | undefined): string => {
  if (!productType) return '';

  // Try to get from the map first
  if (productType in PRODUCT_TYPE_LABELS) {
    return PRODUCT_TYPE_LABELS[productType as ProductType];
  }

  // Fallback: format the raw value (snake_case to Title Case)
  return productType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
